import { GetRowIdParams } from "ag-grid-enterprise";

// After refetch the data ,It help to persist Scroll Bar
export const getRowId = (params: GetRowIdParams<{ id: string }>) =>
  params.data.id;

export const submittalSequenceComparator = (
  valueA: any,
  valueB: any,
  nodeA: any,
  nodeB: any,
  isWithSpecSection = false
) => {
  const valA = Number(valueA);
  const valB = Number(valueB);

  const compareIdOnly = () => {
    if (valA === valB) {
      return 0;
    }
    return valA > valB ? 1 : -1;
  };

  if (isWithSpecSection) {
    const specNoA = nodeA.data.spec_no;
    const specNoB = nodeB.data.spec_no;

    if (specNoA && specNoB) {
      if (specNoA === specNoB) return compareIdOnly();
      const stringA = `${specNoA}${valueA}`;
      const stringB = `${specNoB}${valueB}`;

      return stringA > stringB ? 1 : -1;
    }

    if (!specNoA && !specNoB) return compareIdOnly();
    if (specNoB) return -1;
    return 1;
  }
  return compareIdOnly();
};
